export const namespaces = {
    translation: "translation",
  };
  
  export const languages = {
    de_CH: "de_CH",
    en_GB: "en_GB",
  };